import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Bloquea atrás/adelante del navegador (gestos del trackpad, botones del browser)
 * mientras el componente está montado. La navegación interna con Links sigue funcionando.
 */
export function useBlockBrowserHistoryNavigation(enabled = true) {
  const location = useLocation();
  const navigate = useNavigate();
  const locationRef = React.useRef(location);
  const guardActiveRef = React.useRef(false);

  React.useEffect(() => {
    locationRef.current = location;
  }, [location]);

  React.useEffect(() => {
    if (!enabled) return;

    guardActiveRef.current = true;

    const currentUrl = () => {
      const { pathname, search, hash } = locationRef.current;
      return `${pathname}${search}${hash}`;
    };

    const pushGuard = () => {
      window.history.pushState(
        { browserHistoryBlocked: true },
        "",
        currentUrl()
      );
    };

    pushGuard();

    const onPopState = () => {
      if (!guardActiveRef.current) return;

      const url = currentUrl();
      window.history.pushState({ browserHistoryBlocked: true }, "", url);
      navigate(url, { replace: true });
    };

    window.addEventListener("popstate", onPopState);

    return () => {
      guardActiveRef.current = false;
      window.removeEventListener("popstate", onPopState);
    };
  }, [enabled, navigate]);

  React.useEffect(() => {
    if (!enabled || !guardActiveRef.current) return;

    const url = `${location.pathname}${location.search}${location.hash}`;
    window.history.replaceState({ browserHistoryBlocked: true }, "", url);
  }, [enabled, location.pathname, location.search, location.hash]);
}
